// extracted by mini-css-extract-plugin
export default {"animatedHeader":"AnimatedHeader_animatedHeader__A-8Wk","mainHeader":"AnimatedHeader_mainHeader__30zjg","bgHeader":"AnimatedHeader_bgHeader__Y2IH9"};